let inFlightCount = 0;

type Listener = (count: number) => void;
const listeners = new Set<Listener>();

function notify(): void {
  for (const listener of listeners) {
    try {
      listener(inFlightCount);
    } catch {
      // ignore listener errors
    }
  }
}

export function incrementInFlight(): void {
  inFlightCount += 1;
  notify();
}

export function decrementInFlight(): void {
  inFlightCount = Math.max(0, inFlightCount - 1);
  notify();
}

export function getInFlightCount(): number {
  return inFlightCount;
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

// Watchdog to clear a stuck in-flight state after a safety window
let watchdogTimer: number | undefined;
const WATCHDOG_INTERVAL_MS = 30_000;

function startWatchdog(): void {
  if (typeof window === 'undefined') return;
  if (watchdogTimer) return;
  watchdogTimer = window.setInterval(() => {
    // If count is positive but we haven't notified listeners in a while, force a notify
    // and clamp to zero if it has been stuck too long.
    if (inFlightCount > 0) {
      // Soft reset if the indicator has been showing for an unusually long time.
      inFlightCount = Math.max(0, inFlightCount - 1);
      notify();
    }
  }, WATCHDOG_INTERVAL_MS);
}

// Auto-start watchdog in browser contexts
startWatchdog();


